import { IHttpResponse, ILocationService, IQService, ITimeoutService, route } from "angular";
import { IRouteService } from "./shared/model/route.model";
import { LogBookRootScopeService } from "./shared/model/app.model";
import { LogService } from "../ng/src/app/logs/log.service";
import { LogWithData } from "ng/src/app/logs/log.model";
import { Log } from "ng/src/app/logs/log.model";
import { SimulateLogUserRoleService } from "ng/src/app/shared/simulate-log-user-role.service";

angular.module('logbook')
	.config(['$routeProvider', function($routeProvider: route.IRouteProvider) {
		let originalWhen = $routeProvider.when;

		let logSelection = ['$q', '$rootScope', '$location', '$route', '$timeout', 'logDataService', 'logService', 'simulateLogUserRoleService', (
			$q: IQService,
			$rootScope: LogBookRootScopeService,
			$location: ILocationService,
			$route: IRouteService,
			$timeout: ITimeoutService,
			logDataService: any,
			logService: LogService,
			simulateLogUserRoleService: SimulateLogUserRoleService) => {
				if (!$rootScope.authenticated)
					return $q.reject('not authenticated');

				if (!$rootScope.selectedLog) {
					let defaultLog: string | undefined;

                    try {
						defaultLog = $rootScope.user?.config.defaultLog;
                    }
                    catch (e) {
                        console.error(e);
                    }
                    
					if (!$rootScope.hadDefaultRedirect && defaultLog && parseInt(defaultLog) > 0 && !$location.search().log)
                        $location.search('log', defaultLog);
                    else
                        defaultLog = undefined;

					const deferred = $q.defer();

					let logs;

					const setup = logService.getLogs().toPromise().then(l => {
						logs = l;
						const logId = parseInt($location.search().log);

						if (!logs.length)
							return $q.resolve();
						
						if (logId) {
							const log = logs.find(log => log.id == logId);

							if (log)
								return setupSelectedLog(log);
						}

						if (logs.length == 1 && $location.path() !== '/log-detail')
							return setupSelectedLog(logs[0]);
						
						return $q.resolve();
					})
					.then(() => {
						const hadRedirect = $rootScope.hadDefaultRedirect,
							defaultSelect = logs.length == 1;
						
						$rootScope.hadDefaultRedirect = true;
							
						if (hadRedirect || !$rootScope.selectedLog || $location.path() !== '/logs' ||
							((!defaultLog || !parseInt(defaultLog)) && !defaultSelect))
							return;
						
						return logService.getLogConfigValues('defaultLogPage', $rootScope.selectedLog.id)
							.toPromise().then(lc => {
								$location.url(lc[0]?.value || 'notes');
							});
					})
					.catch(err => console.error(err))
					.finally(() => {
						if (!$rootScope.selectedLog && $route.current!.$$route.logSelectionOptional !== true) {
							$location.url('/logs').replace();
							return $q.reject('no log selected');
						}
						$location.search('log', $rootScope.selectedLog?.id || null).replace();
						return;
					});

					deferred.resolve(setup);

					return deferred.promise;

					function setupSelectedLog (log: Log)  {
						return logService.getLogById(log.id).toPromise().then(
							log => {
								const logbookExpires = log.millisToFeatureExpiration.LogBook;
	
								if (!simulateLogUserRoleService.forceAdminFlag && (!logbookExpires || logbookExpires <= 0) ) {
									deferred.reject('log payment expired');
									console.log('Redirecting to log list because payment is expired');

									$location.url('/logs');
								}
	
								return logDataService.getLogData(log).then(
									() => {
										LogService.selectedLog = $rootScope.selectedLog = log as LogWithData;
										if ($location.path() === '/notes' && LogService.selectedLog.role === 'READ') {
											console.log('Redirecting to recent-notes because user is read only');
											$location.url('/recent-notes');
										}
										deferred.resolve($rootScope.selectedLog);
									},
									(error: IHttpResponse<any>) => {
										deferred.reject('specified log not found');
										console.log(`Redirecting to log list because log not found, ${$location.url()}`);

										$location.url('/logs');
									}
								);
							},
							error => {
								deferred.reject('error accessing specified log');
								console.log(`Redirecting to / due to error retrieving log, ${$location.url()}`);

								$location.url('/');
							}
						);
					}
				}

				if ($location.search().log != $rootScope.selectedLog.id) {
					$location.search('log', $rootScope.selectedLog.id).replace();

					if (!$route.current?.$$route.reloadOnSearch)
						$timeout(() => $route.reload());

					return $q.reject('setting selected log');
				}

				return $q.resolve('selectedLog already set');
			}
		];

		$routeProvider.when = function(path, route) {
			route.resolve || (route.resolve = {});

			if (!route.public && !route.noData) {
				angular.extend(route.resolve, {
					logSelection: logSelection
				});
			}

			return originalWhen.call($routeProvider, path, route);
		};

		$routeProvider.when('/', {
			title: 'Home',
			controller: 'home',
			template: " ",
			tab: 'home',
			logSelectionOptional: true,
			public: true
		})
			.when('/sentinel', {
				title: 'Sentinel',
				controller: 'sentinelController',
				template: require('./sentinel/sentinel.html'),
				tab: 'sentinel',
				helpSection: 'sentinel',
				reloadOnSearch: false
			})
			.when('/onsite', {
				title: 'OnSite',
				controller: 'onsiteController',
				template: require('./onsite/onsite.html'),
				tab: 'onsite',
				helpSection: 'onsite',
				reloadOnSearch: false
			})
			.when('/notes', {
				title: 'Enter Notes',
				template: '<lb-enter-notes></lb-enter-notes>',
				tab: 'enter-notes',
				helpSection: 'view-notes',
				reloadOnSearch: false
			})
			.when('/recent-notes', {
				title: 'Recent Notes',
				template: '<lb-enter-notes></lb-enter-notes>',
				tab: 'view',
				helpSection: 'view-notes',
				reloadOnSearch: false
			})
			.when('/note-query', {
				title: 'Search Notes',
				template: '<note-query></note-query>',
				tab: 'search',
				reloadOnSearch: false,
				helpSection: 'search-notes'
			})
			.when('/note-detail', {
				title: 'Note Detail',
				reloadOnSearch: false,
				template: '<note-detail></note-detail>',
				tab: 'view',
				helpSection: 'view-notes'
			})
			.when('/draft-notes', {
				title: 'Draft Notes',
				template: '<lb-draft-notes-ajs></lb-draft-notes-ajs>',
				tab: 'view',
				helpSection: 'draft-notes'
			})
			.when('/reminder-query', {
				title: 'View Reminder',
				controller: 'reminder-query',
				template: require('./reminders/reminder-query.html'),
				tab: 'reminders',
				reloadOnSearch: false,
				helpSection: 'view-reminders'
			})
			.when('/reminder-detail', {
				title: 'Reminder',
				controller: 'reminder-detail',
				template: require('./reminders/details/reminder-detail.html'),
				tab: 'reminders',
				helpSection: 'new-reminder'
			})
			.when('/settings', {
				title: 'Settings',
				controller: 'user-settings',
				template: require('./users/user-settings.html'),
				tab: 'settings',
				logSelectionOptional: true,
				helpSection: 'user-settings'
			})
			.when('/logs', {
				title: 'Logs',
				template: '<log-list></log-list>',
				tab: 'logs',
				logSelectionOptional: true
			})
			.when('/log-detail', {
				title: 'Log Detail',
				controller: 'log-detail',
				template: require('./log-settings/log-settings-tabs.html'),
				tab: 'logs',
				logSelectionOptional: true,
				reloadOnSearch: false,
				helpSection: 'log-settings'
			})
			.when('/log-audit', {
				title: 'Audit Trail',
				controller: 'log-audit',
				template: require('./logs/log-audit.html'),
				tab: 'logs',
				reloadOnSearch: false
			})
			.when('/oauth-signup', {
				title: 'New Login',
				controller: 'oauth-signup',
				template: require('./account/oauth-signup.html'),
				tab: 'signup',
				logSelectionOptional: true,
				public: true
			})
			.when('/signup', {
				title: 'New Login',
				controller: 'signup',
				template: require('./account/signup.html'),
				tab: 'signup',
				logSelectionOptional: true,
				public: true
			})
			.when('/reset-password', {
				title: 'Reset Password',
				controller: 'reset-password',
				template: require('./account/reset-password.html'),
				tab: 'reset-password',
				logSelectionOptional: true,
				public: true
			})
			.when('/validate-email', {
				title: 'Validate Email',
				controller: 'validate-email',
				template: " ",
				tab: 'validate-email',
				logSelectionOptional: true,
				public: false,
				noData: true
			})
			.when('/validation-required', {
				title: 'Validation Required',
				controller: 'validation-required',
				template: require('./account/validation-required.html'),
				logSelectionOptional: true,
				public: true
			})
			.when('/markdown', {
				title: 'View Document',
				controller: 'markdown',
				template: require('./shared/widgets/markdown.html'),
				logSelectionOptional: true,
				public: true
			})
			.when('/template-chart', {
				title: 'Template Chart',
				controller: 'template-chart',
				template: require('./templates/charts/template-chart.html'),
				tab: 'view',
				reloadOnSearch: false
			})
			.when('/report-manager', {
				title: 'Report Manager',
				controller: 'report-manager',
				template: require('./reports/report-manager.html'),
				tab: 'reports',
				reloadOnSearch: false,
				helpSection: 'report-manager'
			})
			.when('/report-editor', {
				title: 'Report Editor',
				controller: 'report-editor',
				template: require('./reports/report-editor.html'),
				tab: 'reports',
				helpSection: 'report-editor'
			})
			.when('/report-view', {
				title: 'View Report',
				controller: 'report-view',
				template: require('./reports/report-view.html'),
				tab: 'reports',
				reloadOnSearch: false,
				helpSection: 'running-and-using-reports'
			})
			.when('/login', {
				public: true,
				title: 'Login',
				template: require('./authentication/login.html'),
				controller: 'authentication',
				tab: 'login',
				logSelectionOptional: true
			})
			.when('/notifications', {
				title: 'Notifications',
				template: '<notification-page></notification-page>',
				logSelectionOptional: true,
				tab: 'view',
				reloadOnSearch: false,
				helpSection: 'view-notifications'
			})
			.when('/notification-detail', {
				title: 'Notification Detail',
				template: '<notification-entry [full-page]="true"></notification-entry>',
				logSelectionOptional: true,
				tab: 'view',
				reloadOnSearch: false,
				helpSection: 'view-notifications'
			})
			.when('/alert-detail', {
				title: 'Alert Detail',
				template: '<alert-instances></alert-instances>',
				logSelectionOptional: false,
				tab: 'view',
				reloadOnSearch: false,
				helpSection: 'view-alerts'
			})
			.when('/files', {
				title: 'Files',
				template: '<lb-files></lb-files>',
				logSelectionOptional: true
			})
			.when('/shift-sign-on', {
				title: 'Shift Sign On',
				showNavBar: false,
				template: '<lb-single-shift-sign-on></lb-single-shift-sign-on>',
				logSelectionOptional: false
			})
			.otherwise('/');
	}]);
